





import { Component, Vue } from "vue-property-decorator";
import TabBar from "@/basics/tab/TabBar.vue";
import TabItem from "@/basics/tab/TabItem.vue";
import AuthTab, { AuthTabItem } from "@/containers/AuthTab.vue";

@Component({
  components: {
    TabBar,
    TabItem,
    AuthTab
  }
})
export default class TabFrame extends Vue {
  building = null;
  groups = [];

  get loading(): boolean {
    return this.$apollo.loading;
  }

  get tabItems(): AuthTabItem[] {
    const resourceId = this.$route.params.groupId;
    return [
      {
        name: "buildings-list",
        title: "建物リスト",
        scopes: [{ resource: "Group", resourceId, action: "operation" }]
      },
      {
        name: "building-new",
        title: "新規登録",
        scopes: [{ resource: "Group", resourceId, action: "management" }]
      }
    ];
  }
}
